<template>
  <div class="day-log-border" style="height: 100%;">
    <v-row class="pb-1">
      <v-col cols="12" class="text-center">
        <b>{{ dayLog.staffLynxLocalDayOfTheWeek }}</b>
        <br>
        <b>{{ dayLog.staffLynxLocalDateTime | formatDate }}</b>
      </v-col>
    </v-row>
    <div style="overflow-y: auto; overflow-x: hidden; height: 70%;">
      <div v-if="dayLog.clockLogs && dayLog.clockLogs.length > 0">
        <v-row
          v-for="log in dayLog.clockLogs" :key="log.id">
          <v-col cols="12" class="px-0">
            <SummaryItem :item-title="log.stateDescription">
              <template v-slot:content>
                {{ log.staffLynxLocalDateTime | toTimeOnlyString }}
                <v-btn
                  small
                  color="#1565c0"
                  outlined
                  class="ml-2"
                  style="max-width: 5px !important; max-height: 25px !important;"
                  @click="showGeolocationDetailsHandler(log.latitude, log.longitude, log.ipAddress)"
                >
                  <v-icon>location_on</v-icon>
                </v-btn>
              </template>
            </SummaryItem>
          </v-col>
        </v-row>
      </div>
      <div v-else>
        <v-row>
          <v-col cols="12" class="text-center">
            No data available
          </v-col>
        </v-row>
      </div>
    </div>
    <v-row
      style="margin-top: 1px;"
    >
      <v-col cols="12" class="text-center">
        <v-btn
          :color="buttonColor"
          :outlined="buttonOutlined"
          @click="editTimeHandler"
        >
          <span :style="`color: ${buttonFontColor}`">
            Total: {{ parseFloat(dayLog.workedTime).toFixed(2) }} Hours
          </span>
          <v-icon
            v-if="dayLog.state !== this.UPLOADED_TO_TIME_SHEET_ENTRIES"
            medium
            style="margin-left: 5px;"
            right
            :color="buttonFontColor"
          >edit</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <ClockGeolocationDetails
      ref="locationDetailsModal"
      @closeGeolocationDetails="closeGeolocationDetailsHandler"
    ></ClockGeolocationDetails>
    <ClockTimeEdit
      ref="timeEditModal"
      :readonly="readonly"
      @closeTimeEdit="closeTimeEditHandler"
      @totalTimeChanged="totalTimeChangedHandler"
    ></ClockTimeEdit>
  </div>
</template>

<script>
import { SummaryItem } from '@/components/shared/display'
import ClockGeolocationDetails from './ClockGeolocationDetails'
import ClockTimeEdit from './ClockTimeEdit'
import { OK, EDITED, ERROR, UPLOADED_TO_TIME_SHEET_ENTRIES } from '@/lib/constants/clockLogStates'

export default {
  components: {
    SummaryItem,
    ClockGeolocationDetails,
    ClockTimeEdit
  },
  data () {
    return {
      OK,
      EDITED,
      ERROR,
      UPLOADED_TO_TIME_SHEET_ENTRIES
    }
  },
  props: [
    'dayLog',
    'readonly'
  ],
  computed: {
    buttonFontColor () {
      return this.buttonOutlined ? '' : 'white'
    },
    buttonColor () {
      switch (this.dayLog.state) {
        case this.ERROR:
          return 'red'
        case this.UPLOADED_TO_TIME_SHEET_ENTRIES:
          return 'green'
        case this.OK:
        case this.EDITED:
        default:
          return '#1565c0'
      }
    },
    buttonOutlined () {
      return this.dayLog.state === this.OK
    }
  },
  methods: {
    showGeolocationDetailsHandler (latitude, longitude, ipAddress) {
      this.$emit('showGelocationDetails')
      this.$refs.locationDetailsModal.showModal(latitude, longitude, ipAddress)
    },
    closeGeolocationDetailsHandler () {
      this.$emit('closeGeolocationDetails')
    },
    editTimeHandler () {
      this.$emit('showEditTimeModal')
      this.$refs.timeEditModal.showModal(JSON.parse(JSON.stringify(this.dayLog)))
    },
    closeTimeEditHandler () {
      this.$emit('closeTimeEdit')
    },
    totalTimeChangedHandler (dayLog) {
      this.$emit('totalTimeChanged', dayLog)
    }
  }
}
</script>
